<template>
  <div class="mb-5">
    <div class="card col-6 offset-3 mb-4">
      <div class="card-body">
        <h3 class="mb-4 text-center">{{ $t("account.my-profile-information") }}</h3>

        <div class="  mb-4">
          <image-cropper id="imageCropper" :src="form.avatar" @cropperImage="cropperImage" />
          <a href="javascript: void(0);" @click="openCropper">
            <img
              class="avatar-title
                rounded-circle
                bg-light"
              :src="form.avatar"
              style="display: block; max-height: 200px;max-width: 200px; margin-left: auto; margin-right: auto;"
            />
          </a>
          <div class="text-info text-center hand" @click="openCropper"><i class="bx bx-edit-alt text-info mt-1"></i> {{ $t("common.update") }}</div>
        </div>

        <h4 class="text-center text-muted">{{ account.credential.email }}</h4>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('common.name')"
          :label="$t('common.name-surname')"
        />

        <h6 class="mt-2">{{ $t("timezone.name") }}</h6>
        <multiselect
          v-if="timezones"
          v-model="form.timezone"
          track-by="abbr"
          :placeholder="$t('timezone.select-time')"
          :options="timezones"
          :searchable="true"
          :allow-empty="false"
          :show-labels="false"
          label="text"
          @select="onSelect"
        >
        </multiselect>

        <h6 class="mt-2">{{ $t("common.language") }}</h6>
        <multiselect
          v-model="form.language"
          track-by="language"
          :placeholder="$t('common.language-select')"
          :options="languages"
          :searchable="false"
          :allow-empty="false"
          :show-labels="false"
          @select="onSelect"
        >
          <template slot="singleLabel" slot-scope="{ option }">
            <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
            <span class="align-middle">{{ option.title | translate }}</span>
          </template>
          <template slot="option" slot-scope="{ option }">
            <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
            <span class="align-middle">{{ option.title | translate }}</span>
          </template>
        </multiselect>

        <br />

        <div style="display: flex; justify-content: space-between;">
          <sweet-button :disabled="$v.form.$invalid || isUpdating" @click="update()" :loading="isUpdating" variant="success" icon="mdi mdi-check-bold" size="sm">
            {{ $t("common.save") }}
          </sweet-button>
          <sweet-button :loading="isUpdating" variant="danger" icon="bx bx-trash-alt text-white hand  " v-b-modal="'account-delete-option-modal' + account._id" size="sm">
            {{ $t("account.delete-my-account") }}
          </sweet-button>
        </div>
        <AccountDeleteOptionModal :id="'account-delete-option-modal' + account._id" :account="account" :strict="false" @remove="deleteById" />
      </div>
    </div>
  </div>
</template>

<script>
import ImageCropper from "@c/form/image-cropper";
import AccountDeleteOptionModal from "@cc/account-delete-option-modal";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
const defaultImage = require("@/assets/images/avatar.png");

export default {
  components: { ImageCropper, AccountDeleteOptionModal },
  data() {
    return {
      form: { name: undefined, avatar: defaultImage, email: undefined },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(40),
      },
    },
  },
  computed: {
    account() {
      return this.$store.getters["user/account"];
    },
    timezones() {
      return this.$store.getters["localization/timezones"];
    },
    languages() {
      return this.$store.getters["localization/languages"];
    },
    isUpdating() {
      return this.$store.getters["user/isUpdating"];
    },
  },
  mounted() {
    this.$store.dispatch("localization/fetchTimezones");

    this.form = {
      ...this.form,
      ...this.account,
      language: this.languages.find((l) => l.language == this.account.language),
    };
  },

  methods: {
    async update() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      await this.$store.dispatch("user/updateProfile", {
        ...this.form,
        language: this.form.language.language,
      });

      this.$toast.success("Kaydedildi");
    },
    onSelect() {
      //      this.$forceUpdate();
    },

    openCropper() {
      this.$bvModal.show("imageCropper");
    },
    cropperImage(value) {
      this.form.avatar = value;
      this.$bvModal.hide("imageCropper");
    },
    async deleteById(payload) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("user/delete", payload);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
